export const LIST_LOCATIONS = "LIST_LOCATIONS";
export const CREATE_DEVICE = "CREATE_DEVICE";
export const UPDATE_DEVICE = "UPDATE_DEVICE"
export const GET_DEVICE_CODE = "GET_DEVICE_CODE";
export const GET_DEVICE_STATUS = "GET_DEVICE_STATUS";
export const DELETE_DEVICE = "DELETE_DEVICE";